<template>
    <span>{{ value }}</span>
</template>

<script>
export default {
  name: 'CellRendererConcatArray',
  computed: {
    value () {
      const { data, valueField, join } = this.params;

      const joinChar = join || ', ';

      return data[valueField].join(joinChar)
    }
  }
}
</script>
